import { SVGProps, Ref } from "react";

import { Beaker02 as TestnetLogo } from "@hl/base-components/lib/assets/icons.generated";
import BlockchainIconArbitrum from "@hl/base-components/lib/assets/icons.generated/BlockchainIconArbitrum";
import BlockchainIconBase from "@hl/base-components/lib/assets/icons.generated/BlockchainIconBase";
import BlockchainIconEthereum from "@hl/base-components/lib/assets/icons.generated/BlockchainIconEthereum";
import BlockchainIconOptimism from "@hl/base-components/lib/assets/icons.generated/BlockchainIconOptimism";
import BlockchainIconPolygon from "@hl/base-components/lib/assets/icons.generated/BlockchainIconPolygon";
import BlockchainIconZora from "@hl/base-components/lib/assets/icons.generated/BlockchainIconZora";
import { NetworkType } from "@hl/shared-features/lib/apollo/graphql.generated";

import { Maybe } from "apollo/graphql.generated";

type Props = {
  network?: NetworkType | Maybe<NetworkType>;
  ref?: Ref<SVGSVGElement>;
} & SVGProps<SVGSVGElement>;

export default function BlockchainIcon({ network, ...rest }: Props) {
  switch (network) {
    case NetworkType.ETHEREUM:
      return <BlockchainIconEthereum {...rest} />;
    case NetworkType.BASE:
      return <BlockchainIconBase {...rest} />;
    case NetworkType.ARBITRUM:
      return <BlockchainIconArbitrum {...rest} />;
    case NetworkType.POLYGON:
      return <BlockchainIconPolygon {...rest} />;
    case NetworkType.OPTIMISM:
      return <BlockchainIconOptimism {...rest} />;
    case NetworkType.ZORA:
      return <BlockchainIconZora {...rest} />;
    default:
      return <TestnetLogo {...rest} />;
  }
}
